import React, { useEffect } from 'react';
import { ServiceMenu } from '../ServiceMenu';
import { SelectedServiceDetails } from '../BookingModal';
import { navigateTo } from '../../utils/router';

interface ServicesPageProps {
  selectedItems: SelectedServiceDetails[];
  onToggleService: (id: string, name: string, price: number) => void;
  initialCategory?: string | null;
}

export const ServicesPage: React.FC<ServicesPageProps> = ({
  selectedItems,
  onToggleService,
  initialCategory = null
}) => {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    const timer = setTimeout(() => {
      window.scrollTo({ top: 0, left: 0, behavior: 'instant' });
    }, 50);
    return () => clearTimeout(timer);
  }, [initialCategory]);
  return (
    <div className="multipage-view services-page-view">
      <h1 className="sr-only">
        {initialCategory
          ? `${initialCategory.charAt(0).toUpperCase() + initialCategory.slice(1)} at Home in Bhilai & Durg | Blishka Doorstep Services`
          : 'Doorstep Beauty Services & Salon Price Menu | Blishka Bhilai & Durg'}
      </h1>
      <div className="subpage-content-wrapper">
        <ServiceMenu
          selectedServices={selectedItems.map((s) => s.id)}
          onToggleService={onToggleService}
          initialCategory={initialCategory}
          onSelectCategory={(catId) => {
            navigateTo('/services', { category: catId });
          }}
          onBackToCategories={() => {
            navigateTo('/services');
          }}
        />
      </div>
    </div>
  );
};
